export const buildReceiveProductsState = (state, action) => state.concat(action.items);
